import { render, staticRenderFns } from "./merge-merchants.vue?vue&type=template&id=1c65fb6c&scoped=true&"
import script from "./merge-merchants.vue?vue&type=script&lang=js&"
export * from "./merge-merchants.vue?vue&type=script&lang=js&"
import style0 from "./merge-merchants.vue?vue&type=style&index=0&id=1c65fb6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c65fb6c",
  null
  
)

export default component.exports